import {charcoal} from '../../sass/v2/_exports.sass';

export const HeartIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6.12665C14.5472 4.79079 12.6456 4.04938 10.672 4.04932C9.62736 4.0504 8.59327 4.25806 7.62922 4.66034C6.66517 5.06262 5.79019 5.65158 5.05464 6.39332C1.91731 9.54398 1.91864 14.472 5.05731 17.6093L14.8333 27.3853C15.06 27.784 15.4973 28.0413 16 28.0413C16.2064 28.0393 16.4094 27.9889 16.5928 27.8942C16.7762 27.7995 16.9348 27.6631 17.056 27.496L26.9426 17.6093C30.0813 14.4706 30.0813 9.54398 26.94 6.38798C26.2048 5.64761 25.3305 5.05985 24.3674 4.65849C23.4043 4.25714 22.3714 4.05012 21.328 4.04932C19.3544 4.04964 17.4529 4.79101 16 6.12665ZM25.0546 8.27332C27.1386 10.368 27.14 13.64 25.0573 15.724L16 24.7813L6.94264 15.724C4.85997 13.64 4.86131 10.368 6.93997 8.27865C7.95331 7.27065 9.27864 6.71598 10.672 6.71598C12.0653 6.71598 13.3853 7.27065 14.3906 8.27598L15.0573 8.94265C15.181 9.06658 15.328 9.16489 15.4897 9.23197C15.6515 9.29906 15.8249 9.33358 16 9.33358C16.1751 9.33358 16.3485 9.29906 16.5102 9.23197C16.672 9.16489 16.8189 9.06658 16.9426 8.94265L17.6093 8.27598C19.6253 6.26398 23.0413 6.26932 25.0546 8.27332Z"
        fill={color}
      />
    </svg>
  );
};
